import { encode } from './htmlEncoder';
import sanitize from 'sanitize-html';

export default function stripHtml(value: string, withEncode = true) {
  const sanitizedHtml = sanitize(value, {
    allowedTags: [],
    allowedAttributes: {},
  });

  if (withEncode) return encode(sanitizedHtml);

  return sanitizedHtml;
}
